export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("apollo:error", (err) => {
    console.error(err);
    return err;
  });
});
